// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"aecb67d1","207":"6103ed30","213":"93b0609e","239":"5d483402","453":"2fe7592a","789":"895e90d1"}[chunkId] + ".chunk.js";
};